import { Component, OnInit } from '@angular/core';
import { StatisticsService } from '../../../services/statistics.service';
import { TotalsResponse } from '../../../models/totals-response.model';
import { ExportService } from '../../../services/export.service';

@Component({
  selector: 'app-medical-center-statistics',
  templateUrl: './medical-center-statistics.component.html'
})
export class MedicalCenterStatisticsComponent implements OnInit {

  statistics: TotalsResponse;
  loading = false;

  constructor(
    private statisticsService: StatisticsService,
    private exportService: ExportService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.statisticsService.getTotals().subscribe(res => {
      this.statistics = res;
      this.loading = false;
    });
  }

  exportStatistics() {
    this.exportService.export({
      name: 'EXPORT_V0_ALL'
    });
  }
}
